export default {
  app: {
    exportTableAuth: 'btnExport', // 应用导出
    createRowAuth: 'btnAdd', // 新增应用
    deleteRowAuth: 'btnDelete', // 删除应用
    editRowAuth: 'btnEdit' // 编辑应用
  },
  menu: {
    exportTableAuth: 'exportMenuTableAuth', // 导出菜单table
    createMenuAuth: 'btnAddMenu', // 菜单新增按钮
    editMenuAuth: 'btnEditMenu', // 菜单编辑按钮
    deleteRowAuth: 'btnDeleteMenu',
    editRowAuth: 'editMenuRowAuth',
    pageCompomentAuth: 'btnPageComponentAuth', // 页面控件权限
    dataRowAuth: 'btnDataRowAuth', // 数据行权限
    dataColumnAuth: 'btnDataColAuth', // 数据列权限
    deleteColumnAuth: 'deleteColumnAuth',
    editColumnAuth: 'editColumnAuth'
  },
  character: {
    exportTableAuth: 'btnExport', // 导出角色
    createRowAuth: 'btnAdd', // 新建角色
    deleteRowAuth: 'btnDelete', // 删除角色
    editRowAuth: 'btnEdit', // 角色编辑
    userAuth: 'btnEditUsers', // 用户按钮
    roleAuth: 'btnEditAuth' // 角色授权
  },
  // 用户管理组件code
  user: {
    exportTableAuth: 'btnExport', // 用户导出
    setRoleAuth: 'btnEditRoleAuth', // 设置角色
    setPermissionAuth: 'btnEditAuth', // 设置权限
    setAppAuth: 'btnEditAppInAuthUser' // 应用分配
  },
  // bpm管理 - 模版组管理 组件code
  tplGroupManage: {
    create: 'btnAddTplGroup',
    edit: 'btnEditTplGroup',
    export: 'btnExportTplGroup',
    changeStatus: 'btnOpTplGroup'
  },
  // bpm管理 - 审批模版管理 组件code
  tplApprovalManage: {
    create: 'btnUpsertTplConfig',
    edit: 'btnUpsertTplConfig',
    copy: 'btnCopyTplConfig',
    changeStatus: 'btnOpTplConfig'
  },
  // bpm管理 - 数据管理 组件code
  dataManage: {
    change: 'btnTransfer'
  }
};
